import { createHashHistory } from 'history'

import configureStore from 'app-redux/store'

export const history = createHashHistory()

export const store = configureStore(history)
